import { styled } from '@material-ui/core';
import { Alert } from '@ds/react-components';

export const InfoAlert = styled(Alert)({
  marginTop: '18px',
  maxWidth: '910px',
});
